'use client';

import { useUnit } from 'effector-react';
import { Addon } from '@nx-frontend/features/paywall';
import { $ModalStore, closeModalEvent } from '@nx-frontend/shared/ui/modal';
import { generalEnv } from '@nx-frontend/shared/env';
import { $app } from '@nx-frontend/shared/store/app';
import { $currentOrganization } from '@nx-frontend/shared/store/current-organization/current-organization';
import { $session } from '@nx-frontend/shared/store/session';
import { $user } from '@nx-frontend/shared/store/user';
import { AddonPopupPayload, PopupType } from '@nx-frontend/shared/types';
import { GetOpenAddonProps } from '@nx-frontend/shared/types';

/**
 * @deprecated Use `useOpenAddonPopup`
 */
export const getOpenAddonPopup = ({ openModal, payload }: GetOpenAddonProps) => {
  openModal({
    content: PopupType.ADDON,
    showCloseButton: false,
    modalContainerStyles: '!rounded-2xl',
    usePadding: false,
    multipopup: false,
    payload,
  });
};

export function AddonPopup() {
  const [app, user, session, currentOrganization, modalStore, closeModal] = useUnit([
    $app,
    $user,
    $session,
    $currentOrganization,
    $ModalStore,
    closeModalEvent,
  ]);

  const modal = modalStore.find((m) => m.content === PopupType.ADDON);
  const payload = modal?.payload as AddonPopupPayload;

  if (payload) {
    return (
      <Addon
        code={payload.code}
        settings={{
          gatewayUrl: generalEnv.gatewayUrl,
          userBillingUrl: generalEnv.userBillingUrl,
          sessionId: app.sessionId || session.id,
          userId: user.id,
          orgId: currentOrganization.globalId,
        }}
        onClose={closeModal}
      />
    );
  }
  return null;
}
